document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-slider-dots]').forEach((dotNav) => {
        const sectionId = dotNav.getAttribute('data-slider-dots');
        const slider = document.querySelector(`#Slider-${sectionId}`);
        const slides = slider?.querySelectorAll('.slider__slide');
        const dots = dotNav.querySelectorAll('.slider-dot');

        if (!slider || !slides.length || !dots.length) return;

        let userClicked = false;

        const setActiveDot = (index) => {
            dots.forEach((dot, i) => {
                if (i === index) {
                    dot.setAttribute('aria-current', 'true');
                    dot.classList.add('is-active');
                } else {
                    dot.removeAttribute('aria-current');
                    dot.classList.remove('is-active');
                }
            });
        };

        // 🔹 Handle dot click and accessibility attributes
        dots.forEach((dot, index) => {
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            dot.setAttribute('aria-controls', `Slider-${sectionId}`);

            dot.addEventListener('click', () => {
                userClicked = true;
                slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start' });
                setActiveDot(index);

                // Let scroll event take over after animation
                setTimeout(() => {
                    userClicked = false;
                }, 600);
            });
        });

        // 🔹 Handle scroll sync (throttled)
        let lastKnownIndex = 0;

        const updateDotFromScroll = () => {
            if (userClicked) return;

            const sliderLeft = slider.getBoundingClientRect().left;
            let closestIndex = 0;
            let closestDistance = Infinity;

            slides.forEach((slide, i) => {
                const distance = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = i;
                }
            });

            if (closestIndex !== lastKnownIndex) {
                setActiveDot(closestIndex);
                lastKnownIndex = closestIndex;
            }
        };

        // Throttled scroll listener using requestAnimationFrame
        let isThrottled = false;
        slider.addEventListener('scroll', () => {
            if (isThrottled) return;

            isThrottled = true;
            window.requestAnimationFrame(() => {
                updateDotFromScroll();
                isThrottled = false;
            });
        });

        // Set initial state
        setActiveDot(0);
    });
});
